import { Data, useUIActions } from "../../../../../features/ui"
import { useExpensesActions } from "../../../actions/expensesActions"
import { ExpenseType } from "../../../state/types"

export const useActions = () => {
    const expensesActions = useExpensesActions()
    const { onSubmitDataType } = useUIActions()

    const submitExpenseType = async (
        expenseTypeData: Data,
        createMode: boolean
    ) => {
        const { companyId, id, name } = expenseTypeData
        const expenseType: ExpenseType = {
            companyId: companyId as string,
            id: id as string,
            name: name as string
        }
        
        await expensesActions().saveExpenseType(expenseType)
        onSubmitDataType(createMode)
    }
    
    return { submitExpenseType }
}
